import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;

export const getOfferings = (queryParams = "") =>
  instance({ baseURL }).get("/offering" + queryParams);

export const getOfferingById = (id) =>
  instance({ baseURL }).get(`/offering/${id}`);

export const createOffering = (body) =>
  instance({ baseURL }).post("/offering/create", body);

export const saveOffering = (id, body) =>
  instance({ baseURL }).patch(`/offering/${id}`, body);

export const reviseOffering = (id, body) =>
  instance({ baseURL }).put(`/offering/${id}`, body);

export const submitOffering = (id) =>
  instance({ baseURL }).post(`/offering/${id}/submit`);

export const actApproval = (id, body) =>
  instance({ baseURL }).post(`/offering/${id}/approve`, body);

export const sendOffering = (id) =>
  instance({ baseURL }).post(`/offering/${id}/send`);

export const acceptOffering = (id) =>
  instance({ baseURL }).post(`/offering/${id}/accept`);

export const declineOffering = (id) =>
  instance({ baseURL }).post(`/offering/${id}/decline`);

export const cancelOffering = (id) =>
  instance({ baseURL }).post(`/offering/${id}/cancel`);

export const convertOffering = (id) =>
  instance({ baseURL }).post(`/offering/${id}/convert`);

export const setOfferingRevenueScheme = (id, body) =>
  instance({ baseURL }).put(`/offering/${id}/revenue-scheme`, body);
